module.exports = __webpack_public_path__ + "img/3.8d1da6f6.png";